import { render } from "./CookiePolicyView.vue?vue&type=template&id=87df8346&scoped=true"
const script = {}

import "./CookiePolicyView.vue?vue&type=style&index=0&id=87df8346&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87df8346"]])

export default __exports__